module.exports = __webpack_public_path__ + "img/betfury-banner-background.f761b41.png";